import React from 'react';
import { StyledProgressBar } from './style';

export const ProgressBar = ({ percent, width, height }) => {
  return <StyledProgressBar percent={percent} width={width} height={height}></StyledProgressBar>;
};
